import { FormattedDate, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, BodyS, HeadlineS } from '#src/atoms/typography/index.tsx';
import { PlayerAvatar } from '#src/components/seo/PlayerAvatar/index.tsx';
import { FRONTEND_ASSET_HOST } from '#src/constants/assets.ts';

const Flag = styled.img`
  width: var(--double-unit);
`;

type Props = {
  displayName: string;
  manager: {
    displayName: string;
    pictureUrl: string | null;
    startDate: Date;
    country: {
      slug: string;
    };
  };
};

export const Manager = ({ displayName, manager }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Team.Manager.teamManager"
            defaultMessage="{team} manager"
            values={{ team: displayName }}
          />
        </HeadlineS>
        <Horizontal>
          <PlayerAvatar src={manager.pictureUrl} alt={manager.displayName} />
          <Vertical gap={0}>
            <Horizontal>
              <BodyM as="p">{manager.displayName}</BodyM>
              <Flag
                src={`${FRONTEND_ASSET_HOST}/flags/${manager.country.slug}.svg`}
                alt={manager.country.slug}
              />
            </Horizontal>
            <BodyS as="p" color="var(--c-nd-600)">
              <FormattedMessage
                id="Seo.Team.Manager.joinedIn"
                defaultMessage="Joined in <span>{date}</span>"
                values={{
                  date: (
                    <FormattedDate
                      value={manager.startDate}
                      month="long"
                      day="numeric"
                      year="numeric"
                    />
                  ),
                  span: chunks => (
                    <BodyM as="span" color="var(--c-white)">
                      {chunks}
                    </BodyM>
                  ),
                }}
              />
            </BodyS>
          </Vertical>
        </Horizontal>
      </Vertical>
    </FullWidthContainer>
  );
};
